"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgChevronSRight(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "9 -4 6 24" }, props),
        React.createElement("path", { d: "M9.47 11.47a.75.75 0 001.06 1.06l4-4a.75.75 0 000-1.06l-4-4a.75.75 0 00-1.06 1.06L12.94 8z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('ChevronSRight')(SvgChevronSRight);
//# sourceMappingURL=ChevronSRight.js.map